import _ from 'lodash';
import { SIDE_FILTER_KEYS } from './constants';

export const removeFalsyValues = (obj: Record<string, any>): Record<string, any> => {
  return _.omitBy(obj, (value) => {
    const result = !value || (_.isArray(value) && value.length === 0);
    return result;
  });
};

export const removeSideFilterValues = (obj: Record<string, any>): Record<string, any> => {
  const withoutSideFilterKeys = _.omit(obj, Array.from(SIDE_FILTER_KEYS));
  return withoutSideFilterKeys;
};

export const removeFalsyAndSideFilterValues = (obj: Record<string, any>): Record<string, any> => {
  const withoutFalsyValues = removeFalsyValues(obj);
  const withoutSideFilterKeys = removeSideFilterValues(withoutFalsyValues);
  return withoutSideFilterKeys;
};
